import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../config";
import axios from "axios";
import CampusDriveForm from "./CampusDriveForm";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

const CampusDriveEdit = () => {
  const { driveId } = useParams();
  const collegeId = useSelector((state) => state.college_id?.college_id);
  const [drive, setDrive] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchDrive = async () => {
    setLoading(true);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;
    try {
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/CampusDrive/get_campus_drive_job_details_post`,
        {
          params: {
            campus_drive_id: driveId,
            college_id: collegeId,
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.data?.success) {
        setDrive(response.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDrive();
  }, [driveId]);

  if (!loading && !drive) {
    return <div>No drive found</div>;
  }
  return (
    <div>
      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading campus drive...</p>
        </div>
      ) : (
        <CampusDriveForm drive={drive} />
      )}
    </div>
  );
};

export default CampusDriveEdit;
